<template>
  <div type="card-full" style="margin: 20px 30px">
    <div class="other-content" id="px" ref="px" v-if="model">
      <div class="title">
        {{ model.pjnoticetitle }}
      </div>
      <div class="line1"></div>
      <div class="content">
        <div v-html="model.pjnoticedesc" class="content"></div>
      </div>
      <div class="line1" v-if="model.pjnoticedesc"></div>
      <div v-if="model.appendList && model.appendList.length" class="filelist">
        <div
          v-for="(item, index) in model.appendList"
          :key="index"
          class="fileitem"
        >
          <div class="name" @click="downFile(item.appendurl)">
            <a :src="uploadAddr + item.appendurl">{{ item.appendfilename }}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-else>无</div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getLodop } from "@/assets/js/LodopFuncs";
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import dayjs from "dayjs";
import common from "@/mixin/common";
let LODOP;
export default {
  name: "pjnoticeFile",
  mixins: [common],
  data() {
    return {
      type: this.$route.params.type,
      projectid: this.$route.query.projectid,
      pjnoticetype: this.$route.query.Ptype,
      pjnoticeid: this.$route.query.pjnoticeid,
      btnLoading: false,
      model: {},
    };
  },
  created() {},
  filters: {
    newDate(value) {
      return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    qfwVal(value) {
      return utils.comdify(value);
    },
  },
  async mounted() {
    await this.init();
    await this.getModel();
  },
  watch: {
    "$route.query.Ptype": async function (newVal, oldVal) {
      if (newVal != oldVal) {
        await this.init();
        await this.getModel();
      }
    },
  },
  methods: {
    async init() {
      this.btnLoading = false;
      this.model = {};
    },
    async getModel() {
      let cosid = this.$store.getters.loginUser.cosid
        ? this.$store.getters.loginUser.cosid
        : this.$store.getters.expertLoginUser.cosid;
      let id = this.$route.params.projrctid
          ? this.$route.params.projrctid
          : this.$route.query.projectid,
        type = this.$route.params.Ptype
          ? this.$route.params.Ptype
          : this.$route.query.Ptype;
      let res = {}    
      if (type && +type === 2){
        res = await request({
          method: "get",
          url: "/xmgl/pjnotice/getPJNoticeListById",
          params: { pjnoticeid: this.pjnoticeid, pjnoticetype: type, cosid: cosid },
        });
      } else {
        res = await request({
          method: "get",
          url: "/xmgl/pjnotice/getPJNoticeListByprojectId",
          params: { projectid: id, pjnoticetype: type, cosid: cosid },
        });
      }
      this.model = res;
    },
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/table.scss";
.other-content {
  display: flex;
  flex-direction: column;
  // align-items: center;
  /*width: 100vw;*/
  /*height: 100vh;*/

  // overflow: auto;
  // font-weight: bold;
  .title {
    text-align: center;
    font-size: 22px;
    color: #000;
    word-wrap: break-word;
    font-weight: bold;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    // line-height: 18px;
    text-align: left;
    margin: 10px 0;
  }
  .line,
  .line1 {
    width: 100%;
    background: #000;
  }
  .line {
    height: 1px;
    margin-bottom: 4px;
  }
  .line1 {
    height: 1px;
  }
  .content {
    // padding: 10px 20px;
    // line-height: 28px;
  }
  .filelist {
    /*width: 100%;*/
    padding-top: 10px;
    .fileitem {
      display: flex;
      text-align: left;
      // line-height: 25px;
      .name {
        color: #2f74ff;
        cursor: pointer;
      }
    }
  }
}
</style>
